export function legacyBrandWorkspaceRedirect(tab: string | null): Record<string, string> | null {
  if (tab === "brand-content") return { tab: "product-kits", collection: "brand-wide" };
  if (tab === "about") return { tab: "brand-kit" };
  return null;
}
